import { Progress } from "antd"
import { useUploadFilesDataStore, useUploadbarOpenStore } from "store/uploadFiles.store"
import { useEffect, useState } from "react"
import style from "./UploadbarMini.module.scss"

const { uploadbarMini, wrapper, progress } = style

type FilesCount = { total?: number | null; completed?: number | null }

export const UploadbarMini = () => {
	const { triggerOpen } = useUploadbarOpenStore()
	const { allFiles } = useUploadFilesDataStore()

	const [filesCount, setFilesCount] = useState<FilesCount>({
		total: null,
		completed: null,
	})
	const [completedPercentage, setCompletedPercentage] = useState(0)

	const uploadedCount = Object.values(allFiles).reduce((count, { status }) => {
		return status === "uploaded" ? ++count : count
	}, 0)

	useEffect(() => {
		setFilesCount({
			total: Object.keys(allFiles).length,
			completed: uploadedCount,
		})
		if (filesCount.completed && filesCount.total) {
			const completed = (filesCount?.completed / filesCount?.total) * 100
			setCompletedPercentage(completed)
		}
	}, [allFiles, filesCount?.completed, filesCount?.total, uploadedCount])

	const onClickHandle = () => {
		triggerOpen()
	}

	return (
		<button className={uploadbarMini} onClick={onClickHandle}>
			<div className={wrapper}>
				<Progress type="circle" percent={completedPercentage} size={50} showInfo={false} />
				<div className={progress}>{filesCount?.completed + "/" + filesCount?.total}</div>
			</div>
		</button>
	)
}
